import { IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { tableCellTypogrphyStyle } from "../styles"
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface CustomTableCellProps {
    cell: { dataIndex: string, label: string, textWidth?: string }
    value: string,
    row,
    toggleVisibility: Function
    isCellRevealed: boolean
}

export const ShowHideTableCell: React.FC<CustomTableCellProps> = ({ isCellRevealed, toggleVisibility, row, cell, value }) => {
    console.log('ShowHideTableCell props: ', { isCellRevealed, toggleVisibility, row, cell, value })

    //null check for ssn in gaprod
    if (value) {
        if (value === "-" || value.toLowerCase() === "n/a") {
            return (
                <Typography sx={{ ...tableCellTypogrphyStyle, width: cell.textWidth ? cell.textWidth : "max-content" }}>-</Typography>
            )
        }
    } else {
        value = "-"
    }


    return (
        //cell.textWidth is from batch-printing but we may no longer need this. See headerCells file in batch-printing page folder.
        //It's not actually being used anymore but that page needs to be checked in ME or Demo to make sure it's displaying properly. 
        //We may need to add textWidth to the config for that page.
        <>
            <Typography sx={{ ...tableCellTypogrphyStyle, width: cell.textWidth ? cell.textWidth : "max-content", fontSize: `16px` }}>
                {
                    isCellRevealed
                        ? value
                        : '***-**-****'
                }
            </Typography>
            {
                isCellRevealed
                    ? <Tooltip title="Hide">
                        <IconButton size='small'
                            aria-label='Visibility off'
                            data-testid="visibility-off-icon"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleVisibility(row.key)
                            }}>
                            <VisibilityOffIcon sx={{ color: 'action.active' }} fontSize='small' />
                        </IconButton>
                    </Tooltip>

                    : <Tooltip title="Show">
                        <IconButton size='small'
                            aria-label='Visibility on'
                            data-testid="visibility-on-icon"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleVisibility(row.key)
                            }}>
                            <VisibilityIcon sx={{ color: 'action.active' }} fontSize='small' />
                        </IconButton>
                    </Tooltip>

            }
        </>
    )

}